/**
 * The page's Tidy: the shared layout rule (`@repo/shared/workflowLayout`) on
 * an ELK loaded on first use, so the chart's page does not carry it until a
 * tidy is needed. A chart saved before AMO-177 (laid out left to right, no
 * `layout`) is tidied this way the first time it opens.
 *
 * @module components/workflows/workflowLayout
 */
import type { WorkflowGraph } from "@amoreg/contracts";
import { tidyWorkflowGraph as tidyWith, type ElkEngine } from "@repo/shared/workflowLayout";

export { needsRelayout } from "@repo/shared/workflowLayout";

let elk: Promise<ElkEngine> | null = null;

const loadElk = (): Promise<ElkEngine> => {
  elk ??= import("elkjs/lib/elk.bundled.js").then((module) => new module.default() as unknown as ElkEngine);
  return elk;
};

/** The graph laid out top to bottom; `heights` are the cards as drawn. */
export async function tidyWorkflowGraph(graph: WorkflowGraph, heights: Readonly<Record<string, number>> = {}): Promise<WorkflowGraph> {
  return tidyWith(await loadElk(), graph, heights);
}
